const languages = ['en', 'es', 'ca', 'pt'];
export const languagesUpperCased = ['EN', 'ES', 'CA', 'PT'];

export default languages;
